"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.playScoreSettingProps = exports.default = void 0;

var _vue = require("vue");

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _switch = _interopRequireDefault(require("ant-design-vue/lib/switch"));

var _lodash = _interopRequireDefault(require("lodash"));

var _dataMap = require("../utils/dataMap");

var _switchChecked = _interopRequireDefault(require("./assets/images/switch-checked.png"));

var _switchDisabled = _interopRequireDefault(require("./assets/images/switch-disabled.png"));

var _switchUncheck = _interopRequireDefault(require("./assets/images/switch-uncheck.png"));

var _SelectDowmList = _interopRequireDefault(require("./component/SelectDowmList"));

var _radio = _interopRequireWildcard(require("ant-design-vue/lib/radio"));

require("ant-design-vue/lib/radio/style/index.css");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var playScoreSettingProps = {
  playScoreParams: Object,
  partInfo: {
    type: Array
  },
  disabled: {
    type: Boolean,
    default: false
  }
};
exports.playScoreSettingProps = playScoreSettingProps;
var PlayScoreSetting = (0, _vue.defineComponent)({
  name: 'PlayScoreSetting',
  components: {
    Switch: _switch.default,
    SelectDownList: _SelectDowmList.default
  },
  props: playScoreSettingProps,
  emits: ['update:playScoreParams'],
  setup: function setup(props, ctx) {
    var playScoreParams = (0, _vue.reactive)(props.playScoreParams);
    var partInfo = (0, _vue.computed)(function () {
      return props.partInfo;
    });
    var disabled = (0, _vue.computed)(function () {
      return props.disabled;
    });
    var showScore = (0, _vue.ref)(false); //控制评分开关

    var changeScoreBtn = function changeScoreBtn() {
      if (disabled.value) {
        return;
      }

      playScoreParams.score = !playScoreParams.score;
    }; //计算上拉菜单高度


    var partheight = (0, _vue.ref)();

    var changeShowScore = function changeShowScore(flag) {
      if (props.disabled) {
        return;
      }

      if (playScoreParams.score === false) {
        showScore.value = false;
      } else {
        showScore.value = !showScore.value; // 关闭蒙版时一起关闭这个弹窗

        if (flag === false) {
          showScore.value = false;
        }
      }
    };

    (0, _vue.watch)(function () {
      return partInfo.value;
    }, function (newVal) {
      partheight.value = newVal.length;
    }, {
      immediate: true
    }); //控制评分窗口

    (0, _vue.watch)(function () {
      return props.playScoreParams.score;
    }, function (newVal) {
      if (newVal === false) {
        showScore.value = false;
      }
    });
    (0, _vue.watch)(function () {
      return props.playScoreParams;
    }, function (newVal) {
      (0, _extends2.default)(playScoreParams, newVal);
    });
    (0, _vue.watch)(function () {
      return playScoreParams;
    }, function (newVal) {
      // console.log('评分参数变化了', newVal);
      ctx.emit('update:playScoreParams', newVal);
    }, {
      deep: true
    });
    (0, _vue.watch)(function () {
      return playScoreParams.scoreSampleRate;
    }, function (newVal) {
      console.log('scoreSampleRate', newVal);
      localStorage.setItem('scoreSampleRate', newVal);
    }); //数据

    var score = (0, _vue.computed)(function () {
      var cloneScore = _lodash.default.cloneDeep(_dataMap.scoreTypes);

      var score = _lodash.default.uniqBy(cloneScore, 'value').map(function (item) {
        return item;
      });

      return _lodash.default.orderBy(score, ['value'], ['asc']);
    }); //声部

    var part = (0, _vue.computed)(function () {
      var gradeInfo = partInfo.value.map(function (part, index) {
        return {
          label: part.showName,
          value: index + 1
        };
      });

      var clonePart = _lodash.default.cloneDeep(gradeInfo);

      var part = _lodash.default.uniqBy(clonePart, 'value').map(function (item) {
        return item;
      });

      return _lodash.default.orderBy(part, ['value'], ['asc']);
    });
    return {
      playScoreParams: playScoreParams,
      showScore: showScore,
      changeShowScore: changeShowScore,
      score: score,
      part: part,
      partheight: partheight,
      disabled: disabled,
      changeScoreBtn: changeScoreBtn,
      switchUncheck: _switchUncheck.default,
      switchChecked: _switchChecked.default,
      switchDisabled: _switchDisabled.default
    };
  },
  render: function render() {
    var _this = this;

    return (0, _vue.createVNode)("div", {
      "class": "play-score-setting"
    }, [(0, _vue.createVNode)("div", {
      "onClick": this.changeScoreBtn,
      "class": [this.playScoreParams.score ? 'content_on' : 'content_off', !this.playScoreParams.score && this.disabled ? 'content_disabled_off' : this.playScoreParams.score && this.disabled ? 'content_disabled_on' : '']
    }, null), (0, _vue.createVNode)("div", {
      "class": ['scoreBtn', this.playScoreParams.score && !this.disabled ? '' : 'scoreBtn__disabled'],
      "onClick": this.changeShowScore
    }, [(0, _vue.createVNode)("p", null, [(0, _vue.createTextVNode)("\u8BC4\u5206\u9879\u76EE")])]), this.showScore && !this.disabled ? (0, _vue.createVNode)("div", {
      "class": "score-modal"
    }, [(0, _vue.createVNode)("div", {
      "class": "score-container"
    }, [(0, _vue.createVNode)("div", {
      "class": "content-item"
    }, [(0, _vue.createVNode)("div", {
      "class": "content-item-text"
    }, [(0, _vue.createTextVNode)("\u7C7B\u578B")]), (0, _vue.createVNode)(_SelectDowmList.default, {
      "class": "item-selector",
      "theme": "select",
      "selectValue": _this.playScoreParams.scoreType,
      "onUpdate:selectValue": function onUpdateSelectValue($event) {
        return _this.playScoreParams.scoreType = $event;
      },
      "options": this.score,
      "popoverStyle": {
        height: '270px'
      }
    }, null)]), (0, _vue.createVNode)("div", {
      "class": "content-item"
    }, [(0, _vue.createVNode)("div", {
      "class": "content-item-text"
    }, [(0, _vue.createTextVNode)("\u58F0\u90E8")]), (0, _vue.createVNode)(_SelectDowmList.default, {
      "class": "item-selector",
      "theme": "select",
      "selectValue": _this.playScoreParams.scorePart,
      "onUpdate:selectValue": function onUpdateSelectValue($event) {
        return _this.playScoreParams.scorePart = $event;
      },
      "options": this.part,
      "popoverStyle": {
        height: "".concat(this.partheight * 50, "px")
      }
    }, null)]), (0, _vue.createVNode)("div", {
      "class": "content-item"
    }, [(0, _vue.createVNode)("div", {
      "class": "content-item-text"
    }, [(0, _vue.createTextVNode)("\u97F3\u9AD8\u6761")]), this.playScoreParams.pitchBar ? (0, _vue.createVNode)("img", {
      "src": this.switchChecked,
      "onClick": function onClick() {
        return _this.playScoreParams.pitchBar = !_this.playScoreParams.pitchBar;
      }
    }, null) : (0, _vue.createVNode)("img", {
      "src": this.switchUncheck,
      "onClick": function onClick() {
        return _this.playScoreParams.pitchBar = !_this.playScoreParams.pitchBar;
      }
    }, null)]), (0, _vue.createVNode)("div", {
      "class": "content-item"
    }, [(0, _vue.createVNode)(_radio.Group, {
      "value": _this.playScoreParams.scoreLevel,
      "onUpdate:value": function onUpdateValue($event) {
        return _this.playScoreParams.scoreLevel = $event;
      },
      "defaultValue": "0",
      "class": "content-item-radio-group",
      "size": "large"
    }, {
      default: function _default() {
        return [(0, _vue.createVNode)(_radio.default, {
          "class": "radio_button",
          "value": "0"
        }, {
          default: function _default() {
            return [(0, _vue.createTextVNode)("\u5165\u95E8")];
          }
        }), (0, _vue.createVNode)(_radio.default, {
          "class": "radio_button",
          "value": "1"
        }, {
          default: function _default() {
            return [(0, _vue.createTextVNode)("\u4E1A\u4F59")];
          }
        }), (0, _vue.createVNode)(_radio.default, {
          "class": "radio_button",
          "value": "2"
        }, {
          default: function _default() {
            return [(0, _vue.createTextVNode)("\u4E13\u4E1A")];
          }
        })];
      }
    })]), (0, _vue.createVNode)("div", {
      "class": "content-item"
    }, [(0, _vue.createVNode)("div", {
      "class": "content-item-text"
    }, [(0, _vue.createTextVNode)("\u5F55\u97F3\u8D28\u91CF")]), (0, _vue.createVNode)(_radio.Group, {
      "value": _this.playScoreParams.scoreSampleRate,
      "onUpdate:value": function onUpdateValue($event) {
        return _this.playScoreParams.scoreSampleRate = $event;
      },
      "defaultValue": this.playScoreParams.scoreSampleRate,
      "class": "content-item-radio-group",
      "size": "large"
    }, {
      default: function _default() {
        return [(0, _vue.createVNode)(_radio.default, {
          "class": "radio_button",
          "value": "0"
        }, {
          default: function _default() {
            return [(0, _vue.createTextVNode)("\u4F4E")];
          }
        }), (0, _vue.createVNode)(_radio.default, {
          "class": "radio_button",
          "value": "1"
        }, {
          default: function _default() {
            return [(0, _vue.createTextVNode)("\u9AD8")];
          }
        })];
      }
    })])])]) : '']);
  }
});

PlayScoreSetting.install = function (app) {
  app.component(PlayScoreSetting.name, PlayScoreSetting);
  return app;
};

var _default2 = PlayScoreSetting;
exports.default = _default2;